.dialogContent {
  display: flex;
  flex-direction: column;
  padding: 16px;
}
